



















































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import { uniqueId } from 'lodash-es';
import { mapState } from 'vuex';
import MemberProfileExperienceForm from '@adobe/edex/frontend/views/member/member-profile-experience-form.vue';
import MemberProfileExperienceItem from '@adobe/edex/frontend/views/member/member-profile-experience-item.vue';

const TEMP_ID_PREFIX = 'temp';
const TEMP_ID = () => uniqueId(TEMP_ID_PREFIX);

export default {
  props: ['profile'],
  components: {
    MemberProfileExperienceForm,
    MemberProfileExperienceItem,
    draggable: () =>
      import(/* webpackChunkName: "vuedraggable" */ 'vuedraggable'),
  },
  data() {
    return {
      editMode: false,
      loading: false,
      formData: null,
      attempted: false,
      items: [...this.profile.experience],
      MODAL_NAME: uniqueId('new-experience'),
      drag: false,
    };
  },
  computed: {
    ...mapState('member', ['member']),
    ...mapState('metadata', [
      'schoolTypes',
      'educationSegments',
      'jobFunctions',
      'countries',
      'regions',
    ]),
    canEdit() {
      return this.profile.id === this.member?.id;
    },
  },
  methods: {
    onEdit() {
      this.editMode = true;
    },
    onCancel() {
      this.items = [...this.profile.experience];
      this.editMode = false;
    },
    onAdd() {
      this.formData = {};
    },
    onEditItem(experience) {
      this.formData = { ...experience, currentlyWorkHere: !experience.endDate };
    },
    onRemoveItem(experience) {
      this.items = this.items.filter(item => item.id !== experience.id);
    },
    async onUpdate() {
      const experience = this.items.map(item => {
        const {
          id,
          jobTitle,
          institution,
          jobFunction,
          city,
          country,
          region,
          startDate,
          endDate,
          educationSegments,
          schoolType,
          description,
          currentlyWorkHere,
        } = item;
        const data = {
          id: id.startsWith(TEMP_ID_PREFIX) ? null : id,
          i18nCountry: country?.i18nLabel,
          i18nRegion: region?.i18nLabel || '',
          jobFunctionID: jobFunction?.id,
          schoolTypeID: schoolType?.id,
          educationSegments: educationSegments?.map(({ id }) => id),
          endDate: currentlyWorkHere ? null : endDate,
          institution,
          city,
          jobTitle,
          startDate,
          description,
        };
        return data;
      });
      this.loading = true;
      const { data } = await memberAPI.updateSelfExperience({
        experience,
      });
      this.loading = false;
      this.$emit('updated', data);
      this.editMode = false;
    },
    async onFormSubmit(data) {
      const { id } = data;
      if (id) {
        this.items = this.items.map(item =>
          item.id === id ? { ...item, ...data } : item
        );
      } else {
        this.items.push({ ...data, id: TEMP_ID() });
      }
      this.formData = null;
    },
  },
};
